// API configuration - base URL for backend API
export const API_BASE_URL = process.env.REACT_APP_API_URL || ""; 